import type { ReactNode } from 'react';

/** Content widths (spec §3.2): wide screens hold two panes from lg, reading screens one column. */
export const PAGE_WIDTHS = {
  wide: 'max-w-[75rem]',
  reading: 'max-w-3xl',
  narrow: 'max-w-md',
} as const;

export function Page({
  width = 'reading',
  className = '',
  children,
}: {
  width?: keyof typeof PAGE_WIDTHS;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={`mx-auto w-full ${PAGE_WIDTHS[width]} space-y-4 p-4 ${className}`}>
      {children}
    </div>
  );
}
